module.exports = __webpack_public_path__ + "img/carbon-footprint-icon.325588e8.svg";